import { Table } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import {
	QUES_CODE_PREFIX,
	formatBrsrNumericCellValue,
	getFormattedTextEmbeddedinLITag
} from '../../../../core/utilities/BRSRUtils';
import './BRSRSectionBGridLayout.scss';
import './../Reporting.scss';

const P_INDICES = [1, 2, 3, 4, 5, 6, 7, 8, 9];

const buildAnswerMap = (page2, questionCode) => {
	const answer = {};
	page2?.currentYear?.[questionCode]?.keyValues?.forEach((val) => {
		answer[val.key] = formatBrsrNumericCellValue(val.value);
	});
	return answer;
};

const PrincipleHeaderRow = ({ t }) => (
	<tr>
		<th scope="col" className="brsr-section-b-grid__disclosure-col">
			{t('BRSRSectionBGridLayout.disclosureQuestions.header.label')}
		</th>
		{P_INDICES.map((p) => (
			<th key={p} scope="col" className="brsr-section-b-grid__p-header text-center">
				{t('BRSRSectionBGridLayout.principle.header.label', { n: p })}
			</th>
		))}
	</tr>
);

const PrincipleCells = ({ answer, keyPrefix }) =>
	P_INDICES.map((p) => (
		<td key={p} className="brsr-section-b-grid__p-cell text-center">
			{answer[`${keyPrefix}P${p}`] ?? ''}
		</td>
	));

const SectionBannerRow = ({ colSpan, children }) => (
	<tr>
		<td colSpan={colSpan} className="brsr-section-b-grid__section-banner font-color">
			<strong>{children}</strong>
		</td>
	</tr>
);

const BRSRSectionBGridLayout = ({ t, page2 }) => {
	const answer27 = buildAnswerMap(page2, `${QUES_CODE_PREFIX}27`);
	const answer28 = buildAnswerMap(page2, `${QUES_CODE_PREFIX}28`);
	const answer29 = buildAnswerMap(page2, `${QUES_CODE_PREFIX}29`);

	const colSpanMain = 10;

	return (
		<section id="Section_B" className="Main_Section Section_B brsr-section-b-grid" data-testid="brsr-section-b-grid">
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 1">
					<div className="ETA_card_Section_head">
						<h5>{t('BRSRSectionBGridLayout.sectionTitle.label')}</h5>
					</div>
					<div className="ETA_card_Section_sub">
						<p>{t('BRSRSectionBGridLayout.sectionIntro.label')}</p>
						<section className="mb-4">
							<div className="ETA_card_Section_sub_body">
								<Table responsive bordered size="sm" className="brsr-section-b-grid__main-table">
									<thead>
										<PrincipleHeaderRow t={t} />
									</thead>
									<tbody>
										<SectionBannerRow colSpan={colSpanMain}>
											{t('BRSRSectionBGridLayout.policyManagement.banner.label')}
										</SectionBannerRow>
										<tr>
											<td className="brsr-section-b-grid__disclosure-col">
												<div className="table_list01">
													<b>1.</b>{' '}
													{t('BRSRSectionBGridLayout.q1a.text.label')}
												</div>
											</td>
											<PrincipleCells answer={answer27} keyPrefix={`${QUES_CODE_PREFIX}27-1a`} />
										</tr>
										<tr>
											<td className="brsr-section-b-grid__disclosure-col">
												<div className="table_list01">{t('BRSRSectionBGridLayout.q1b.text.label')}</div>
											</td>
											<PrincipleCells answer={answer27} keyPrefix={`${QUES_CODE_PREFIX}27-1b`} />
										</tr>
										<tr>
											<td className="brsr-section-b-grid__disclosure-col">
												<div className="table_list01">{t('BRSRSectionBGridLayout.q1c.text.label')}</div>
											</td>
											<PrincipleCells answer={answer27} keyPrefix={`${QUES_CODE_PREFIX}27-1c`} />
										</tr>
										<tr>
											<td className="brsr-section-b-grid__disclosure-col">
												<div className="table_list01">{t('BRSRSectionBGridLayout.q2.text.label')}</div>
											</td>
											<PrincipleCells answer={answer27} keyPrefix={`${QUES_CODE_PREFIX}27-2`} />
										</tr>
										<tr>
											<td className="brsr-section-b-grid__disclosure-col">
												<div className="table_list01">{t('BRSRSectionBGridLayout.q3.text.label')}</div>
											</td>
											<PrincipleCells answer={answer27} keyPrefix={`${QUES_CODE_PREFIX}27-3`} />
										</tr>
										<tr>
											<td className="brsr-section-b-grid__disclosure-col">
												<div className="table_list01">{t('BRSRSectionBGridLayout.q4.text.label')}</div>
											</td>
											<PrincipleCells answer={answer27} keyPrefix={`${QUES_CODE_PREFIX}27-4`} />
										</tr>
										<tr>
											<td className="brsr-section-b-grid__disclosure-col">
												<div className="table_list01">{t('BRSRSectionBGridLayout.q5.text.label')}</div>
											</td>
											<PrincipleCells answer={answer27} keyPrefix={`${QUES_CODE_PREFIX}27-5`} />
										</tr>
										<tr>
											<td className="brsr-section-b-grid__disclosure-col">
												<div className="table_list01">{t('BRSRSectionBGridLayout.q6.text.label')}</div>
											</td>
											<PrincipleCells answer={answer27} keyPrefix={`${QUES_CODE_PREFIX}27-6`} />
										</tr>

										<SectionBannerRow colSpan={colSpanMain}>
											{t('BRSRSectionBGridLayout.governance.banner.label')}
										</SectionBannerRow>
										<tr>
											<td className="brsr-section-b-grid__disclosure-col">
												<div className="table_list01">{t('BRSRSectionBGridLayout.q7.text.label')}</div>
											</td>
											<td colSpan={9} className="brsr-section-b-grid__narrative-cell">
												{getFormattedTextEmbeddedinLITag(answer27[`${QUES_CODE_PREFIX}27-7`] ?? '')}
											</td>
										</tr>
										<tr>
											<td className="brsr-section-b-grid__disclosure-col">
												<div className="table_list01">{t('BRSRSectionBGridLayout.q8.text.label')}</div>
											</td>
											<td colSpan={9} className="brsr-section-b-grid__narrative-cell">
												{getFormattedTextEmbeddedinLITag(answer27[`${QUES_CODE_PREFIX}27-8`] ?? '')}
											</td>
										</tr>
										<tr>
											<td className="brsr-section-b-grid__disclosure-col">
												<div className="table_list01">{t('BRSRSectionBGridLayout.q9.text.label')}</div>
											</td>
											<td colSpan={9} className="brsr-section-b-grid__narrative-cell">
												{getFormattedTextEmbeddedinLITag(answer27[`${QUES_CODE_PREFIX}27-9`] ?? '')}
											</td>
										</tr>
									</tbody>
								</Table>

								<div className="brsr-section-b-grid__q10-block mt-3">
									<div className="table_list01 mb-2">
										<b>{t('BRSRSectionBGridLayout.q10.title.label')}</b>
									</div>
									<Table responsive bordered size="sm" className="brsr-section-b-grid__nested-table">
										<thead>
											<tr>
												<th scope="col" rowSpan={2} className="brsr-section-b-grid__subject-col align-middle">
													{t('BRSRSectionBGridLayout.q10.subjectForReview.header.label')}
												</th>
												<th scope="colgroup" colSpan={9} className="text-center brsr-section-b-grid__group-header">
													{t('BRSRSectionBGridLayout.q10.reviewUndertaken.header.label')}
												</th>
												<th scope="colgroup" colSpan={9} className="text-center brsr-section-b-grid__group-header">
													{t('BRSRSectionBGridLayout.q10.frequency.header.label')}
												</th>
											</tr>
											<tr>
												{P_INDICES.map((p) => (
													<th key={`ru-${p}`} scope="col" className="text-center brsr-section-b-grid__p-subheader">
														{t('BRSRSectionBGridLayout.principle.header.label', { n: p })}
													</th>
												))}
												{P_INDICES.map((p) => (
													<th key={`fr-${p}`} scope="col" className="text-center brsr-section-b-grid__p-subheader">
														{t('BRSRSectionBGridLayout.principle.header.label', { n: p })}
													</th>
												))}
											</tr>
										</thead>
										<tbody>
											<tr>
												<td className="brsr-section-b-grid__subject-col">
													{t('BRSRSectionBGridLayout.q10.rowPerformance.label')}
												</td>
												<PrincipleCells answer={answer28} keyPrefix={`${QUES_CODE_PREFIX}28-10aa`} />
												<PrincipleCells answer={answer28} keyPrefix={`${QUES_CODE_PREFIX}28-10ab`} />
											</tr>
											<tr>
												<td className="brsr-section-b-grid__subject-col">
													{t('BRSRSectionBGridLayout.q10.rowCompliance.label')}
												</td>
												<PrincipleCells answer={answer28} keyPrefix={`${QUES_CODE_PREFIX}28-10ba`} />
												<PrincipleCells answer={answer28} keyPrefix={`${QUES_CODE_PREFIX}28-10bb`} />
											</tr>
										</tbody>
									</Table>
								</div>

								<Table responsive bordered size="sm" className="brsr-section-b-grid__main-table mt-3">
									<thead>
										<tr>
											<th scope="col" className="brsr-section-b-grid__disclosure-col" />
											{P_INDICES.map((p) => (
												<th key={p} scope="col" className="text-center brsr-section-b-grid__p-header">
													{t('BRSRSectionBGridLayout.principle.header.label', { n: p })}
												</th>
											))}
										</tr>
									</thead>
									<tbody>
										<tr>
											<td className="brsr-section-b-grid__disclosure-col">
												<div className="table_list01">{t('BRSRSectionBGridLayout.q11.text.label')}</div>
											</td>
											<PrincipleCells answer={answer28} keyPrefix={`${QUES_CODE_PREFIX}28-11`} />
										</tr>
									</tbody>
								</Table>

								<div className="brsr-section-b-grid__q12-block mt-3">
									<div className="table_list01 mb-2">
										<b>{t('BRSRSectionBGridLayout.q12.intro.label')}</b>
									</div>
									<Table responsive bordered size="sm" className="brsr-section-b-grid__nested-table">
										<thead>
											<tr>
												<th scope="col" className="brsr-section-b-grid__disclosure-col">
													{t('BRSRSectionBGridLayout.q12.questionsColumn.header.label')}
												</th>
												{P_INDICES.map((p) => (
													<th key={p} scope="col" className="text-center brsr-section-b-grid__p-header">
														{t('BRSRSectionBGridLayout.principle.header.label', { n: p })}
													</th>
												))}
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>{t('BRSRSectionBGridLayout.q12.rowA.label')}</td>
												<PrincipleCells answer={answer29} keyPrefix={`${QUES_CODE_PREFIX}29-a`} />
											</tr>
											<tr>
												<td>{t('BRSRSectionBGridLayout.q12.rowB.label')}</td>
												<PrincipleCells answer={answer29} keyPrefix={`${QUES_CODE_PREFIX}29-b`} />
											</tr>
											<tr>
												<td>{t('BRSRSectionBGridLayout.q12.rowC.label')}</td>
												<PrincipleCells answer={answer29} keyPrefix={`${QUES_CODE_PREFIX}29-c`} />
											</tr>
											<tr>
												<td>{t('BRSRSectionBGridLayout.q12.rowD.label')}</td>
												<PrincipleCells answer={answer29} keyPrefix={`${QUES_CODE_PREFIX}29-d`} />
											</tr>
											<tr>
												<td>{t('BRSRSectionBGridLayout.q12.rowE.label')}</td>
												<PrincipleCells answer={answer29} keyPrefix={`${QUES_CODE_PREFIX}29-e`} />
											</tr>
										</tbody>
									</Table>
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</section>
	);
};

export default withTranslation()(BRSRSectionBGridLayout);
